import React from 'react';

/* helper → always pulls from /public/assets/images/ */
const img = (file) => `${process.env.PUBLIC_URL}/assets/images/${file}`;

export default function Translations() {
  return (
    <div className="page">
      {/* ──────────  PAGE-TITLE  ────────── */}
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="page-title-heading ttm-textcolor-white">
                  <h2 className="title">Language</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ──────────  SITE-MAIN  ────────── */}
      <div className="site-main">

        {/* ========== 1 ▸ INTRO / HERO BLOCK ========== */}
        <section className="ttm-row pt-70 pb-50 res-991-pb-40 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="ttm-team-member-single-content">
                  <div className="ttm-team-member-single-content-area">
                    <div className="row align-items-center">
                      {/* image */}
                      <div className="col-lg-5 col-md-6">
                        <div className="ttm-featured-wrapper">
                          <div className="featured-thumbnail text-center">
                            <img
                              className="img-fluid"
                              src={img('team-member/team-img01.jpg')}
                              alt="team"
                            />
                          </div>
                        </div>
                      </div>

                      {/* headline + blurb */}
                      <div className="col-lg-5 col-md-6">
                        <div className="ttm-team-member-content pl-20">
                          <div className="ttm-team-member-single-list">
                            <h2 className="ttm-team-member-single-title">
                              Expert Translation Services for Indian Languages
                            </h2>
                            <span className="ttm-team-member-single-position">
                              Professional Translations Service
                            </span>
                            <div className="ttm-team-data">
                              <div className="ttm-team-details-wrapper">
                                <p>
                                  At <strong>Meta Mind Inc</strong>, we deliver accurate,
                                  culturally nuanced translations across major Indian
                                  languages—including Hindi, Bengali, Tamil, Telugu,
                                  Marathi, Gujarati, Kannada, Malayalam, Punjabi, and
                                  more. Our linguists are native speakers and domain
                                  experts who ensure every document, website, or
                                  communication is not just linguistically correct but
                                  also culturally relevant. Whether you're reaching
                                  regional markets or engaging a diverse Indian
                                  audience, our language solutions ensure your message
                                  resonates with clarity and impact.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{/* row */}

                    {/* about paragraphs */}
                    <div className="ttm-team-member-content-about">
                      <h3>
                        Professional Translation Services Tailored for Local &amp;
                        National Impact
                      </h3>
                      <p>
                        At <strong>Meta Mind Inc</strong>, we provide high-quality,
                        precise translations that bridge linguistic diversity across
                        India. Our expert linguists—fluent in regional languages and
                        cultural nuances—ensure your message is conveyed with accuracy
                        and sensitivity. From legal and technical documentation to
                        educational, e-commerce, and marketing content, we offer
                        customized translation solutions aligned with your audience’s
                        language and context.
                      </p>
                      <p>
                        <strong>Meta Mind Inc</strong> specializes in Indian regional
                        language services such as Hindi, Tamil, Bengali, Marathi,
                        Telugu, Malayalam, Kannada, Gujarati, and others. Our
                        native-speaking professionals preserve tone, clarity, and
                        intent—helping your brand connect effectively across India’s
                        multilingual landscape.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== 2 ▸ EXPERTISE & STATS ========== */}
        <section className="ttm-row expertise-section ttm-bgcolor-grey pt-60 pb-60 clearfix">
          <div className="container">
            <div className="row">
              {/* left column – icon bullets */}
              <div className="col-lg-6">
                <div className="res-991-pb-40">
                  <h3>Our Journey</h3>
                  <p>
                    <strong>Meta Mind Inc</strong> has been a trusted name in
                    India’s translation industry, offering high-quality, culturally
                    accurate language solutions. Our journey began with a commitment
                    to bridging communication gaps across India’s multilingual
                    population—and today, we continue to empower businesses through
                    language excellence.
                  </p>

                  {/* bullet 1 */}
                  <div className="featured-icon-box icon-align-before-content icon-ver_align-top mt-25">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                        <i className="flaticon-call-center-agent" />
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>Regional Language Expertise</h5>
                      </div>
                      <div className="featured-desc">
                        <p>
                          We specialize in translating content across Indian
                          languages including Hindi, Tamil, Telugu, Bengali, Marathi,
                          Gujarati, Kannada, Malayalam, Punjabi, and more. Each
                          project is handled by native speakers with deep cultural
                          understanding.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* bullet 2 */}
                  <div className="featured-icon-box icon-align-before-content icon-ver_align-top mt-25">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                        <i className="flaticon-conversation-2" />
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>Industry-Focused Solutions</h5>
                      </div>
                      <div className="featured-desc">
                        <p>
                          We provide translation services for a wide range of
                          industries, including legal, medical, education, finance,
                          government, e-commerce, marketing, and IT/software
                          localization. Our experts ensure contextually relevant and
                          technically accurate content every time.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* right column – progress bars */}
              <div className="col-lg-6 col-md-12">
                <div className="pr-40 res-991-pr-0">
                  <h3>Our Experience</h3>
                  <div className="pt-15">
                    {[
                      ['Certified Translators Across Indian Languages', 95],
                      ['Client Satisfaction Rate', 98],
                      ['Industry-Specific Translation Accuracy', 97],
                      ['Project Turnaround Timeliness', 92],
                      ['Repeat Client Engagements', 90],
                    ].map(([label, pct]) => (
                      <div
                        key={label}
                        className="ttm-progress-bar clearfix"
                        data-percent={`${pct}%`}
                      >
                        <div className="progressbar-title">{label}</div>
                        <div className="progress-bar-inner">
                          <div className="progress-bar progress-bar-color-bar_skincolor" />
                        </div>
                        <div
                          className="progress-bar-percent"
                          data-percentage={pct}
                        >{`${pct}%`}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== 3 ▸ CTA / INFO BLOCK ========== */}
        <section className="ttm-row cta-form-section pt-60 pb-70 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h3>Translation Services That Connect India</h3>
                <p>
                  <strong>Meta Mind Inc</strong> offers expert translation services
                  across a wide spectrum of Indian regional languages including
                  Hindi, Bengali, Tamil, Telugu, Marathi, Gujarati, Kannada,
                  Malayalam, Punjabi, and more. We help businesses, organizations,
                  and institutions break language barriers and connect authentically
                  with local audiences.
                </p>
                <p>
                  Our team of native-language translators, domain specialists, and
                  editors ensure every word is accurate, culturally adapted, and
                  aligned with your goals. Whether it's a legal document, a
                  healthcare report, educational content, or a multilingual
                  marketing campaign, we deliver translation solutions you can
                  trust.
                </p>
                <p>
                  Let Meta Mind Inc be your partner in regional outreach,
                  compliance communication, and audience engagement across India's
                  diverse linguistic landscape.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>{/* site-main */}
    </div>
  );
}